module.exports = __webpack_public_path__ + "static/img/bike.8cd2d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bike.png
// module id = +SOA
// module chunks = 1